import * as Yup from 'yup';

export default (yup: typeof Yup) => ({
  retentionPeriod: yup.number()
    .min(3, 'The minimum is 3 months.')
    .required(),
});
